'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;

	function init() {

		context.find('[data-binding="section-toggle"]').on('click', function () {
			$(this).toggleClass('open');
			$(this).next().toggle();
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/reserve-plan-your-visit.js
// module id = 499
// module chunks = 0